import { useFlags } from "launchdarkly-react-client-sdk";
import { Control, useWatch } from "react-hook-form";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Box from "@mui/material/Box";

import SelectFormField from "components/select-form-field";
import { MANDATORY_REFERRAL_SOURCE_ON_APPOINTMENT_MODAL } from "constants/feature-flags";
import useReferralSourceOptions from "features/patients/use-referral-source-options.hook";
import { useGetReferralSourceQuery } from "services/referral-sources";

import { AppointmentFormValues } from "../appointment-form.component";

type ReferralSourceFieldProps = {
  control: Control<AppointmentFormValues, object>;
  afterUpdate: () => void;
};

export default function ReferralSourceField({
  control,
  afterUpdate
}: ReferralSourceFieldProps) {
  const flags = useFlags();
  const isMandatory = flags[MANDATORY_REFERRAL_SOURCE_ON_APPOINTMENT_MODAL];

  const referralSourceValue = useWatch({ control, name: "referral_source" });
  const referralSourceId = referralSourceValue
    ? Number(referralSourceValue)
    : null;

  const { data: referralSourceData } = useGetReferralSourceQuery(
    referralSourceId!,
    { skip: !referralSourceId }
  );

  const referralSourceOptions = useReferralSourceOptions(
    referralSourceData ?? null
  );

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <AccountCircleOutlinedIcon sx={{ mt: 1.5, mr: 1.5 }} color="action" />
      <SelectFormField
        name="referral_source"
        label="Referral Source"
        control={control}
        options={referralSourceOptions}
        afterUpdate={afterUpdate}
        required={isMandatory}
      />
    </Box>
  );
}
